import { observable, computed, makeObservable } from 'mobx';

import { ContactPersonData, Optional } from 'chaika-frontend-types/frontend-cms';

export interface ContactPersonParams {
    firstName: string;
    lastName: string;
    patronymic?: string;
    phone: string;
}

export class ContactPerson {
    @observable
    public firstName: string;

    @observable
    public lastName: string;

    @observable
    public patronymic: Optional<string>;

    @observable
    public phone: string;

    public constructor({ firstName, lastName, patronymic, phone }: ContactPersonData) {
        makeObservable(this);

        this.firstName = firstName;
        this.lastName = lastName;
        this.patronymic = patronymic;
        this.phone = phone;
    }

    @computed
    public get fullName(): string {
        return `${this.lastName} ${this.firstName} ${this.patronymic ?? ''}`;
    }

    @computed
    public get shortFullName(): string {
        return `${this.lastName} ${this.firstName}`;
    }

    public serialize(): ContactPersonData {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            patronymic: this.patronymic,
            phone: this.phone,
        };
    }
}
